var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6145 18.8856L15.199 14.4702C16.4581 13.0221 17.1059 11.1418 17.0057 9.22554C16.9055 7.30926 16.0652 5.50674 14.6619 4.19795C13.2586 2.88916 11.4019 2.17634 9.48333 2.20976C7.56473 2.24317 5.73405 3.02021 4.37718 4.37707C3.02032 5.73394 2.24328 7.56462 2.20986 9.48323C2.17645 11.4018 2.88927 13.2585 4.19806 14.6618C5.50685 16.065 7.30937 16.9054 9.22564 17.0056C11.1419 17.1058 13.0222 16.458 14.4703 15.1989L18.8857 19.6144C18.9835 19.7055 19.1128 19.755 19.2463 19.7527C19.3799 19.7503 19.5074 19.6962 19.6018 19.6017C19.6963 19.5073 19.7504 19.3798 19.7528 19.2462C19.7551 19.1127 19.7056 18.9834 19.6145 18.8856ZM3.26573 9.625C3.26573 8.36723 3.6387 7.13771 4.33748 6.09192C5.03626 5.04613 6.02945 4.23103 7.19148 3.7497C8.3535 3.26838 9.63216 3.14244 10.8658 3.38782C12.0994 3.6332 13.2325 4.23887 14.1219 5.12824C15.0112 6.01762 15.6169 7.15075 15.8623 8.38435C16.1077 9.61794 15.9817 10.8966 15.5004 12.0586C15.0191 13.2207 14.204 14.2138 13.1582 14.9126C12.1124 15.6114 10.8829 15.9844 9.62511 15.9844C7.93912 15.9823 6.32278 15.3117 5.13061 14.1195C3.93844 12.9273 3.26778 11.311 3.26573 9.625Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.435f615e169ddd1ef9f18c8375750ecc.svg";
export { ForwardRef as ReactComponent };